export default __webpack_public_path__ + "choose_corner_1.f5f51f.svg";